var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.21 438.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b06a2c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.28,359.32s-53-266.8,127-316.8,529.72-143,466.36,326L541.76,438.9S387.28-213.87,7.28,359.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.28,359.32,39,419.12S59.56,279,96.92,241.27L29.48,219.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.85,124.61,112.28,301.52S215.2,178.25,216.74,143.38,277.85,124.61,277.85,124.61Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset25);
export default __webpack_public_path__ + "static/media/Asset 25.93e3db2a.svg";
export { ForwardRef as ReactComponent };